import { render, staticRenderFns } from "./VaFileUploadList.vue?vue&type=template&id=148d6d1d&"
import script from "./VaFileUploadList.vue?vue&type=script&lang=js&"
export * from "./VaFileUploadList.vue?vue&type=script&lang=js&"
import style0 from "./VaFileUploadList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports